import { setupNewLinkListeners } from "@/routes/links/new-link/store/listeners";
import { startAppListening } from "@/store/store";



export const listenerSubscriptions = [
  ...setupNewLinkListeners(startAppListening)
];